import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ROLE_OPTIONS, getAssignableRoles } from "@/lib/roles";
import { useAuth } from "@/context/AuthContext";
import { PermsMatrix } from "@/components/PermsMatrix";
import { PermsSection, EmpresasSelector } from "./PermsSection";

export function UsuarioEditDialog({
  open, onClose, editForm, setEditForm, entregadores, empresas, customPresets,
  onSave, onTogglePerm, onToggleEmpresa, onSetAllPerms, onApplyPreset,
  onOpenSavePreset, onDeleteCustomPreset,
}) {
  const { user } = useAuth();
  const assignableRoles = getAssignableRoles(user);
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="w-[95vw] max-w-5xl max-h-[90vh] overflow-y-auto p-4 sm:p-6" data-testid="dialog-edit-user">
        <DialogHeader className="pb-2 border-b sticky top-0 bg-white z-10 -mx-4 sm:-mx-6 px-4 sm:px-6">
          <DialogTitle>Editar Usuário</DialogTitle>
        </DialogHeader>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 pt-3">
          <div><Label>Nome</Label>
            <Input value={editForm.nome || ""} data-testid="edit-user-nome"
              onChange={(e) => setEditForm({ ...editForm, nome: e.target.value })} /></div>
          <div><Label>Email</Label>
            <Input type="email" value={editForm.email || ""} data-testid="edit-user-email"
              onChange={(e) => setEditForm({ ...editForm, email: e.target.value })} /></div>
          <div><Label>Usuário curto (opcional)</Label>
            <Input value={editForm.username || ""} placeholder="ex: roger" data-testid="edit-user-username"
              onChange={(e) => setEditForm({ ...editForm, username: e.target.value.replace(/\s+/g, "").toLowerCase() })} /></div>
          <div><Label>Nova senha <span className="text-xs text-muted-foreground">(opcional)</span></Label>
            <Input type="password" value={editForm.senha || ""} data-testid="edit-user-senha"
              onChange={(e) => setEditForm({ ...editForm, senha: e.target.value })}
              placeholder="Deixe vazio para manter" /></div>
          <div><Label>Perfil do Usuário</Label>
            <Select value={editForm.role} onValueChange={(v) => setEditForm({ ...editForm, role: v })}>
              <SelectTrigger data-testid="edit-user-role"><SelectValue /></SelectTrigger>
              <SelectContent>
                {assignableRoles.map((r) => (
                  <SelectItem key={r.value} value={r.value} data-testid={`edit-role-opt-${r.value}`}>
                    <div className="flex flex-col">
                      <span className="font-semibold">{r.label}</span>
                      <span className="text-[10px] text-muted-foreground">{r.hint}</span>
                    </div>
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className="col-span-2">
            <div className="text-sm font-semibold mb-2">Vincular a Entregador</div>
            <Select value={editForm.entregador_id || "__none__"}
              onValueChange={(v) => setEditForm({ ...editForm, entregador_id: v === "__none__" ? "" : v })}>
              <SelectTrigger data-testid="edit-user-entregador"><SelectValue placeholder="Nenhum" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="__none__">— Nenhum —</SelectItem>
                {entregadores.map((e) => <SelectItem key={e.id} value={e.id}>{e.nome}</SelectItem>)}
              </SelectContent>
            </Select>
            <p className="text-xs text-muted-foreground mt-1">
              Vincular = usuário ao logar é levado direto à tela mobile de entregas.
            </p>
          </div>
          <div className="col-span-2">
            <div className="text-sm font-semibold mb-2">Empresas de acesso</div>
            <EmpresasSelector empresas={empresas} selectedIds={editForm.empresa_ids}
              onToggle={onToggleEmpresa} target="edit" testIdPrefix="edit" />
            <p className="text-xs text-muted-foreground mt-1">Super Admin sempre tem acesso a todas as empresas.</p>
          </div>
          <div className="col-span-2">
            <PermsSection
              target="edit"
              permissions={editForm.permissions}
              customPresets={customPresets}
              onApplyPreset={onApplyPreset}
              onDeleteCustomPreset={onDeleteCustomPreset}
              onSetAllPerms={onSetAllPerms}
              onOpenSavePreset={onOpenSavePreset}
              onTogglePerm={onTogglePerm}
              testIdPrefix="edit-"
            />
          </div>
        </div>
        <div className="mt-4">
          <PermsMatrix value={editForm.perms_matrix} onChange={(m) => setEditForm({ ...editForm, perms_matrix: m })} testIdPrefix="edit-matrix" />
        </div>
        <div className="sticky bottom-0 bg-white pt-3 -mx-4 sm:-mx-6 px-4 sm:px-6 border-t mt-4">
          <Button onClick={onSave} className="w-full bg-orange-600 hover:bg-orange-700" data-testid="btn-save-user">
            Salvar Alterações
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
